import {
  getLaborUnions,
  getLaborUnionsEmployee,
  getLaborUnionGraphicData,
  getUnionWorkerInformation,
  getDownloadReportService,
  getLaborUnionSocieties,
  getLaborUnionSocietyConventionalPeriodService,
  getPeriodConventional,
} from "@/services/modules/permisos-sindicales/v2/statistics/service";

const state = () => ({
  laborUnions: [],
  employees: [],
  laborGraphicsData: [],
  laborWorkerInformation: [],
  downloadReport: [],
  laborUnionSocieties: [],
  periodConvetionals: [],
  conventionalPeriod: {
    conventional_agreement: "No aplica",
    days: {
      additional: 0,
      available: 0,
      total: 0,
      used: 0,
    },
    ticket_nationals: {
      additional: 0,
      available: 0,
      total: 0,
      used: 0,
    },
    ticket_internationals: {
      additional: 0,
      available: 0,
      total: 0,
      used: 0,
    },
    total_ticket: 0,
    total_ticket_national_international_used: 0,
  },
});

const mutations = {
  SET_LABOR_UNIONS(state, laborUnions) {
    state.laborUnions = laborUnions;
  },
  SET_LABOR_UNIONS_EMPLOYEE(state, employee = []) {
    state.employees = employee;
  },
  SET_LABOR_GRAPHICS_DATA(state, graphic = []) {
    state.laborGraphicsData = graphic;
  },
  SET_LABOR_WORKER_INFORMATION(state, workerInformation = []) {
    state.laborWorkerInformation = workerInformation;
  },
  SET_LABOR_DOWNLOAD_REPORT(state, result) {
    state.downloadReport = result;
  },
  SET_CLEAR_FILTERS(state) {
    state.employees = [];
    state.laborWorkerInformation = [];
    state.laborGraphicsData = [];
    state.laborUnionSocieties = [];
    state.conventionalPeriod = {
      conventional_agreement: "No aplica",
      days: {
        additional: 0,
        available: 0,
        total: 0,
        used: 0,
      },
      ticket_nationals: {
        additional: 0,
        available: 0,
        total: 0,
        used: 0,
      },
      ticket_internationals: {
        additional: 0,
        available: 0,
        total: 0,
        used: 0,
      },
      total_ticket: 0,
      total_ticket_national_international_used: 0,
    };
    state.periodConvetionals = [];
  },
  SET_LABOR_UNION_SOCIETIES(state, data = []) {
    state.laborUnionSocieties = data;
  },
  SET_LABOR_UNION_SOCIETY_CONVENTIONAL_PERIOD(
    state,
    {
      conventional_agreement,
      days,
      ticket_internationals,
      ticket_nationals,
      total_ticket_national_international_used,
    }
  ) {
    state.conventionalPeriod.conventional_agreement =
      conventional_agreement.replace("-", "  Hasta ");
    state.conventionalPeriod.days = days;
    state.conventionalPeriod.ticket_internationals = ticket_internationals;
    state.conventionalPeriod.ticket_nationals = ticket_nationals;
    state.conventionalPeriod.total_ticket_national_international_used =
      total_ticket_national_international_used;
    state.conventionalPeriod.total_ticket =
      ticket_nationals.total + ticket_internationals.total;
  },
  SET_CLEAR_GRAPHIC_DATA(state) {
    state.laborGraphicsData = [];
    state.conventionalPeriod = {
      conventional_agreement: "No aplica",
      days: {
        additional: 0,
        available: 0,
        total: 0,
        used: 0,
      },
      ticket_nationals: {
        additional: 0,
        available: 0,
        total: 0,
        used: 0,
      },
      ticket_internationals: {
        additional: 0,
        available: 0,
        total: 0,
        used: 0,
      },
      total_ticket: 0,
      total_ticket_national_international_used: 0,
    };
  },
  SET_PERIOD_CONVENTIONALS(state, data = []) {
    state.periodConvetionals = data;
  },
};

const actions = {
  async getTest({ commit }) {
    const { result } = await getLaborUnions();
    commit("SET_LABOR_UNIONS", result);
  },
  async getTestEmployee({ commit }, { id, data = {} }) {
    const { result } = await getLaborUnionsEmployee(id, data);
    commit("SET_LABOR_UNIONS_EMPLOYEE", result);
  },
  async getLaborGraphicData({ commit }, dataGraphic) {
    const { result } = await getLaborUnionGraphicData(dataGraphic);
    commit("SET_LABOR_GRAPHICS_DATA", result);
  },
  async getWorkerInformation({ commit }, dataWorker) {
    const { result } = await getUnionWorkerInformation(dataWorker);
    commit("SET_LABOR_WORKER_INFORMATION", result);
  },
  async getDownloadReport({ commit }, data = {}) {
    const { result } = await getDownloadReportService(data);
    commit("SET_LABOR_DOWNLOAD_REPORT", result);
  },
  async getLaborUnionsSocieties({ commit }, id = 0) {
    const { result } = await getLaborUnionSocieties(id);
    commit("SET_LABOR_UNION_SOCIETIES", result);
  },
  async getPeriodConvetionals({ commit }, { societyId, laborUnionId }) {
    const records = [];
    const { result } = await getPeriodConventional(societyId, laborUnionId);
    result?.data?.forEach(element => {
      records.push({
        id: element.id,
        name: `${element?.initial_year} / ${element?.end_year}`,
        end_year: element?.end_year,
        initial_year: element?.initial_year,
      });
    });
    commit("SET_PERIOD_CONVENTIONALS", records);
  },
  async getLaborUnionsSocietyConventionalPeriod(
    { commit },
    { unionId = 0, society = 0, conventionalAgreement = false, data = {} }
  ) {
    const {
      result: {
        conventional_agreement,
        days,
        ticket_nationals,
        ticket_internationals,
        total_ticket_national_international_used,
      },
    } = await getLaborUnionSocietyConventionalPeriodService(
      unionId,
      society,
      conventionalAgreement,
      data
    );

    commit("SET_LABOR_UNION_SOCIETY_CONVENTIONAL_PERIOD", {
      conventional_agreement,
      days,
      ticket_internationals,
      ticket_nationals,
      total_ticket_national_international_used,
    });
  },
  clearFilters({ commit }) {
    commit("SET_CLEAR_FILTERS");
  },
  clearGraphicData({ commit }) {
    commit("SET_CLEAR_GRAPHIC_DATA");
  },
};

const getters = {
  getLaborUnions: (state) => {
    return state.laborUnions;
  },
  getEmployees: (state) => {
    return state.employees;
  },
  getGraphicDataUnion: (state) => {
    return state.laborGraphicsData;
  },
  getLaborWorkerInformation: (state) => {
    return state.laborWorkerInformation;
  },
  getLaborDownloadReport: (state) => {
    return state.downloadReport;
  },
  getLaborUnionSocieties: (state) => {
    return state.laborUnionSocieties;
  },
  getLaborUnionSocietyConventionalPeriod: (state) => {
    return state.conventionalPeriod;
  },
  getPeriodConvertionals: (state) => {
    return state.periodConvetionals;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
